import { Parametric } from '../cliente/parametric.model';
import { BackendModel, BackendService } from '../core/backend.service';

export class NotificacionWho extends BackendModel {

  static path = '/notificaciones/';

  respuesta: string;
  notificacionId: number;
  leido: Boolean;
  clienteId: number;
  createdAt: Date;
  
}



// WEBPACK FOOTER //
// ./src/app/notificacion/notificacionWho.model.ts